<template>
  <v-container>
    <v-card>
      <Card
        :gameId="gameId"
        :currentWord="currentWord"
        :tabooWords="tabooWords"
      />
      <v-btn
        width="33.33333%"
        x-large
        depressed
        outlined
        color="red"
        @click="taboo"
        >✘</v-btn
      >
      <v-btn
        width="33.33333%"
        x-large
        depressed
        outlined
        color="black"
        @click="pass"
        >→</v-btn
      >
      <v-btn
        width="33.33333%"
        x-large
        depressed
        outlined
        color="green"
        @click="correct"
        >✔</v-btn
      >
    </v-card>
  </v-container>
</template>

<script>
import refs from "./firebase/refs";
import Card from "./Card";
import game_play from "./firebase/game_play";

export default {
  name: "CardWithButtons",
  props: {
    gameId: String,
    playerKey: String,
  },
  components: {
    Card,
  },
  created() {
    console.log("created card");
    refs.currentCard(this.gameId).on(
      "value",
      (snapshot) => {
        this.currentWord = snapshot.val().word;
        this.tabooWords = snapshot.val().tabooWords;
      },
      (error) => {
        console.log("err", error);
      }
    );

    this.$root.$once("end-turn", () => {
      console.log("passing on end turn");
      this.pass();
    });
  },
  methods: {
    async taboo() {
      await game_play.taboo(this.gameId, this.currentWord, this.playerKey);
    },
    async pass() {
      await game_play.pass(this.gameId, this.currentWord, this.playerKey);
    },
    async correct() {
      await game_play.correct(this.gameId, this.currentWord, this.playerKey);
    },
  },
  data() {
    return {
      currentWord: "",
      tabooWords: [],
    };
  },
};
</script>
